import { QueryClient } from "react-query";
export var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: process.env.NODE_ENV === "production",
        },
    },
});
